import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { Login } from '@/components/Login';
import { resolveLoginRedirect } from '@/lib/login-redirect';

type IndexSearch = {
  redirect?: string;
};

export const Route = createFileRoute('/')({
  validateSearch: (search: Record<string, unknown>): IndexSearch => ({
    redirect: typeof search.redirect === 'string' ? search.redirect : undefined,
  }),
  component: IndexPage,
});

function IndexPage() {
  const { isAuthenticated, isInitializing, checkAuth } = useAuthStore();
  const { redirect } = Route.useSearch();
  const redirectTo = resolveLoginRedirect(redirect);

  useEffect(() => {
    if (isInitializing) {
      checkAuth();
    }
  }, [isInitializing, checkAuth]);

  if (isInitializing) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to={redirectTo as '/dashboard'} />;
  }

  return <Login redirectTo={redirectTo} />;
}
